import axios from "axios";
import { store } from "../../store/store";
const sortBy = (sortField, direction = "asc") => {
  return (a, b) => {
    if (a[sortField] < b[sortField]) {
      return direction === "asc" ? -1 : 1;
    }
    if (a[sortField] > b[sortField]) {
      return direction === "asc" ? 1 : -1;
    }
    return 0;
  };
};
// Use the questionKey parameter to get scores for that particular question only
export const scoresByPlayer = () => {
  const api =
    "https://nimechanukaapi.tuni.ke/api/challenge/trivia/players/top/five";
  const qs = require("qs");
  let results;
  axios({
    method: "post",
    url: api,
    data: qs.stringify({
      trivia_id: store.state.matchSlug,
      isp: store.state.isp,
      player_id: store.state.scores.playerOne.id,
      question_id: store.state.question_id,
    }),
    headers: {
      "content-type": "application/x-www-form-urlencoded;charset=utf-8",
    },
  }).then((response) => {
    store.commit(
      "setPlayers",
      Object.values(response.data.data).sort(sortBy("points", "desc"))
    );
    store.commit("setMessage", response.data.message_tip);
  });
};
